import type { PageConfigurationType } from '@app/types/'

export function createPageConfiguration(): PageConfigurationType {
  return {
    A4_WIDTH: 21.0,
    A4_HEIGHT: 29.7,
    LETTER_WIDTH: 21.59,
    LETTER_HEIGHT: 27.94,
    TOP_MARGIN_OFFSET: 0.3,
    BOTTOM_MARGIN_OFFSET: 0.6,
    PPCM: 118.11,

    pageWidth: 0,
    pageHeight: 0,
    topMargin: 0,
    bottomMargin: 0,
    footerHeight: 0,
    landscapeFooterHeight: 0,
    headerHeight: 0,
    landscapeHeaderHeight: 0,

    minimumFooterHeight(): number {
      return Math.floor(
        (this.bottomMargin - this.BOTTOM_MARGIN_OFFSET) * this.PPCM
      )
    },

    minimumHeaderHeight(): number {
      return Math.floor((this.topMargin - this.TOP_MARGIN_OFFSET) * this.PPCM)
    },

    fullWidth(): number {
      return Math.floor(this.pageWidth * this.PPCM)
    },

    fullLandscapeWidth(): number {
      return Math.floor(this.pageHeight * this.PPCM)
    },

    setPageSize(pageSize: string): void {
      if (pageSize === 'A4') {
        this.pageWidth = this.A4_WIDTH
        this.pageHeight = this.A4_HEIGHT
      } else if (pageSize === 'LETTER') {
        this.pageWidth = this.LETTER_WIDTH
        this.pageHeight = this.LETTER_HEIGHT
      }
    },

    setTopMargin(topMargin: number): void {
      this.topMargin = topMargin
    },

    setBottomMargin(bottomMargin: number): void {
      this.bottomMargin = bottomMargin
    },

    doChecks(): void {
      const footerHintElement = document.getElementById(
        'footer-hint'
      ) as HTMLDivElement
      footerHintElement.textContent = window.I18n.t(
        'tooltips.export_configurations.image_format_hint',
        { height: this.minimumFooterHeight(), width: this.fullWidth() }
      )

      const landscapeFooterHintElement = document.getElementById(
        'landscape-footer-hint'
      ) as HTMLDivElement
      if (landscapeFooterHintElement) {
        landscapeFooterHintElement.textContent = window.I18n.t(
          'tooltips.export_configurations.image_format_hint',
          {
            height: this.minimumFooterHeight(),
            width: this.fullLandscapeWidth(),
          }
        )
      }

      const headerHintElement = document.getElementById(
        'header-hint'
      ) as HTMLDivElement
      headerHintElement.textContent = window.I18n.t(
        'tooltips.export_configurations.image_format_hint',
        { height: this.minimumHeaderHeight(), width: this.fullWidth() }
      )

      const landscapeHeaderHintElement = document.getElementById(
        'landscape-header-hint'
      ) as HTMLDivElement
      if (landscapeHeaderHintElement) {
        landscapeHeaderHintElement.textContent = window.I18n.t(
          'tooltips.export_configurations.image_format_hint',
          {
            height: this.minimumHeaderHeight(),
            width: this.fullLandscapeWidth(),
          }
        )
      }

      if (
        this.footerHeight > 0 &&
        this.footerHeight < this.minimumFooterHeight()
      ) {
        const footerWarningElement = document.getElementById(
          'footer-warning'
        ) as HTMLDivElement
        footerWarningElement.textContent = window.I18n.t(
          'tooltips.export_configurations.image_format_warning',
          { height: this.minimumFooterHeight(), margin: this.bottomMargin }
        )
      } else {
        const footerWarningElement = document.getElementById(
          'footer-warning'
        ) as HTMLDivElement
        footerWarningElement.textContent = ''
      }

      if (
        this.landscapeFooterHeight > 0 &&
        this.landscapeFooterHeight < this.minimumFooterHeight()
      ) {
        const landscapeFooterWarningElement = document.getElementById(
          'landscape-footer-warning'
        ) as HTMLDivElement
        if (landscapeFooterWarningElement) {
          landscapeFooterWarningElement.textContent = window.I18n.t(
            'tooltips.export_configurations.image_format_warning',
            { height: this.minimumFooterHeight(), margin: this.bottomMargin }
          )
        }
      } else {
        const landscapeFooterWarningElement = document.getElementById(
          'landscape-footer-warning'
        ) as HTMLDivElement
        if (landscapeFooterWarningElement) {
          landscapeFooterWarningElement.textContent = ''
        }
      }

      if (
        this.headerHeight > 0 &&
        this.headerHeight < this.minimumHeaderHeight()
      ) {
        const headerWarningElement = document.getElementById(
          'header-warning'
        ) as HTMLDivElement
        headerWarningElement.textContent = window.I18n.t(
          'tooltips.export_configurations.image_format_warning',
          { height: this.minimumHeaderHeight(), margin: this.topMargin }
        )
      } else {
        const headerWarningElement = document.getElementById(
          'header-warning'
        ) as HTMLDivElement
        headerWarningElement.textContent = ''
      }

      if (
        this.landscapeHeaderHeight > 0 &&
        this.landscapeHeaderHeight < this.minimumHeaderHeight()
      ) {
        const landscapeHeaderWarningElement = document.getElementById(
          'landscape-header-warning'
        ) as HTMLDivElement
        if (landscapeHeaderWarningElement) {
          landscapeHeaderWarningElement.textContent = window.I18n.t(
            'tooltips.export_configurations.image_format_warning',
            { height: this.minimumHeaderHeight(), margin: this.topMargin }
          )
        }
      } else {
        const landscapeHeaderWarningElement = document.getElementById(
          'landscape-header-warning'
        ) as HTMLDivElement
        if (landscapeHeaderWarningElement) {
          landscapeHeaderWarningElement.textContent = ''
        }
      }
    },
  }
}

export default createPageConfiguration
